/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Directive, ElementRef, Renderer2 } from "@angular/core";
import { COMPUTE_WIDTH_CLASS } from "./constants";
import { DatagridRenderOrganizer } from "./render-organizer";
var DatagridTableRenderer = (function () {
    function DatagridTableRenderer(el, renderer, organizer) {
        var _this = this;
        this.el = el;
        this.renderer = renderer;
        this.subscription = organizer.tableMode.subscribe(function (on) { return _this.tableMode(on); });
    }
    DatagridTableRenderer.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    DatagridTableRenderer.prototype.tableMode = function (on) {
        if (on) {
            this.renderer.addClass(this.el.nativeElement, COMPUTE_WIDTH_CLASS);
        }
        else {
            this.renderer.removeClass(this.el.nativeElement, COMPUTE_WIDTH_CLASS);
        }
    };
    return DatagridTableRenderer;
}());
export { DatagridTableRenderer };
DatagridTableRenderer.decorators = [
    { type: Directive, args: [{
                selector: "[clrDgTableWrapper]"
            },] },
];
/** @nocollapse */
DatagridTableRenderer.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
    { type: DatagridRenderOrganizer, },
]; };
//# sourceMappingURL=table-renderer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/datagrid/render/table-renderer.js
// module id = 295
// module chunks = 4